'use client'
import Button from '@mui/material/Button'
import { Link } from '@/i18n/navigation'

function CustomButton({ children, ...props }) {
  return (
    <Button LinkComponent={Link} {...props}>
      {children}
    </Button>
  )
}

export default CustomButton
